import styles from "./empty-state.module.scss";

type IllustrationKind = "search" | "filter";

interface EmptyStateIllustrationProps {
  kind: IllustrationKind;
}

function SearchMark({ x, y, color }: { x: number; y: number; color: string }) {
  return (
    <g
      transform={`translate(${x} ${y})`}
      fill="none"
      stroke={color}
      strokeWidth="2.2"
      strokeLinecap="round"
    >
      <circle cx="16.5" cy="16.5" r="9.5" />
      <path d="M24.2 24.2 33.5 33.5" />
    </g>
  );
}

function FilterMark({ x, y, color }: { x: number; y: number; color: string }) {
  return (
    <g
      transform={`translate(${x} ${y})`}
      fill="none"
      stroke={color}
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M7.5 9.5h25L22.8 21.8v8.4l-5.6 2.4V21.8L7.5 9.5Z" />
    </g>
  );
}

/**
 * Composição do Figma (`ilu-no-search` / `ilu-no-filters`): círculo fantasma,
 * ícone principal no disco branco e os mesmos adornos em ambos os cenários.
 */
export function EmptyStateIllustration({ kind }: EmptyStateIllustrationProps) {
  const Mark = kind === "search" ? SearchMark : FilterMark;

  return (
    <svg
      className={styles.illustration}
      width="216"
      height="113"
      viewBox="0 0 216 113"
      fill="none"
      aria-hidden
      data-illustration={kind}
    >
      <defs>
        <filter id={`empty-state-shadow-${kind}`} x="-40%" y="-40%" width="180%" height="180%">
          <feDropShadow
            dx="0"
            dy="3.13"
            stdDeviation="7.8"
            floodColor="rgb(0, 42, 58)"
            floodOpacity="0.2"
          />
        </filter>
      </defs>

      <circle cx="107" cy="72" r="41" fill="#F2F8F9" stroke="#DDEAF0" />
      <Mark x={87} y={52} color="#DDEAF0" />

      <rect
        x="0"
        y="14.05"
        width="8.94"
        height="8.94"
        rx="1.57"
        fill="#DDEAF0"
        transform="rotate(45 4.47 18.52)"
      />
      <rect
        x="168.33"
        y="98.62"
        width="8.94"
        height="8.94"
        rx="1.57"
        fill="#DDEAF0"
        transform="rotate(45 172.8 103.09)"
      />
      <path
        d="M22.77 7v7.05M19.24 10.53h7.05"
        stroke="#DDEAF0"
        strokeWidth="1.57"
        strokeLinecap="round"
      />
      <path
        d="M168.48 28.14v7.05M164.95 31.67h7.05"
        stroke="#DDEAF0"
        strokeWidth="1.57"
        strokeLinecap="round"
      />
      <circle cx="141.07" cy="12.1" r="3.53" stroke="#DDEAF0" strokeWidth="1.57" />
      <circle cx="32.5" cy="107.62" r="3.53" stroke="#DDEAF0" strokeWidth="1.57" />

      <circle cx="80" cy="40" r="40" fill="#FFFFFF" filter={`url(#empty-state-shadow-${kind})`} />
      <Mark x={60} y={20} color="#0F748F" />
    </svg>
  );
}
